<template>
<div class="w100" style="background-color: #212121;">
    c
        <v-data-table
        v-if="showdata == 'TLC'"
        :headers="headers"
        dense
        class="va-table w100"
        :items="summaries"
        :items-per-page="10000"
        hide-default-footer
        >
         <template v-slot:body="{ items }">
            <tbody>
                <tr v-for="(item,index) in items" :key="index">          
                    <td class="text-left">{{ item.fishcar }}</td>
                    <td class="text-right">{{ $money(item.ticket) }}</td>
                    <td class="text-right">{{ $money(item.parking) }}</td>
                    <td class="text-right">{{ $money(item.labor2) }}</td>
                    <td class="text-right">{{ $money(item.commission) }}</td>
                    <td class="text-right">
                    {{ 
                    $money($IsNum(item.ticket) + $IsNum(item.parking) + $IsNum(item.labor2) + $IsNum(item.commission))
                    }}
                    </td>
                    <td class="text-right">{{ $money(item.gross_sales) }}</td>
                    <td class="text-right">{{ $money(item.net_sales) }}</td>
                </tr>
            </tbody>
               <tfoot >
                <tr class="font-weight-bold" >          
                    <td class="text-right" style="border-top: 1px solid #212121;">TOTAL</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(TICKET) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(PARKING) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(LABOR) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(COMMISSION) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(TOTAL) }} </td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(GROSS) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(NET) }}</td>
                </tr>
                
            </tfoot>
        </template>
        </v-data-table>

        <v-data-table
        v-if="showdata == 'FISHCAR SALES'"
        :headers="headers2"
        dense
        class="va-table"
        :items="summaries"
        :items-per-page="10000"
        hide-default-footer
        >
         <template v-slot:body="{ items }">
            <tbody>
                <tr v-for="(item,index) in items" :key="index">          
                    <td class="text-left">{{ item.fishcar }}</td>
                    <td class="text-right">{{ $money(item.total_kilos) }}</td>
                    <td class="text-right">{{ $money(item.cash_sales) }}</td>
                    <td class="text-right">{{ $money(item.service_charge) }}</td>
                    <td class="text-right">{{ $money(item.credit_sales) }}</td>
                    <td class="text-right">{{ $money(item.service_charge_credit) }}</td>
                    <td class="text-right">{{ $money($IsNum(item.cash_sales) + $IsNum(item.credit_sales)) }}</td>
                </tr>
            </tbody>
               <tfoot >
                <tr class="font-weight-bold" >          
                    <td class="text-right" style="border-top: 1px solid #212121;">TOTAL</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(KILOS) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(CASH) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(SC_CASH) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(CREDIT) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(SC_CREDIT) }} </td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(GROSS) }}</td>
                </tr>
                
            </tfoot>
        </template>
        </v-data-table>
   
</div>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    selected_date: {
        type: String,
        default: ''
    },
    showdata: {
        type: String,
        default:'TCL'
    }
  },
   data: () => ({
      summaries: [],
      supplier:{},
      textRules: [
        v => !!v || 'Field is required'
      ],
       headers: [
            { text: 'Fishcar', sortable: false},
            { text: 'Ticket', align:"right" , sortable: false},
            { text: 'Parking', align:"right", sortable: false},
            { text: 'Labor', align:"right", sortable: false},
            { text: 'Comm', align:"right", sortable: false},
            { text: 'Total', align:"right", sortable: false},
            { text: 'Gross', align:"right", sortable: false},
             { text: 'Net', align:"right", sortable: false},
      ],
      headers2: [
            { text: 'Fishcar'},
            { text: 'Kilos', align:"right" , sortable: false},
            { text: 'Cash', align:"right" , sortable: false},
            { text: 'Service', align:"right" , sortable: false},
            { text: 'Credit', align:"right" , sortable: false},
             { text: 'Service', align:"right" , sortable: false},
            { text: 'Total', align:"right" , sortable: false}
      ]
  }),
  created(){
       this.getTCL()
  },
  computed:{
      TICKET(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.ticket), 0)
           return total
      },
      PARKING(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.parking), 0)
           return total
      },
      LABOR(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.labor2), 0)
           return total
      },
      COMMISSION(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.commission), 0)
           return total
      },
     KILOS(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.total_kilos), 0)
           return total
      },
      CASH(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.cash_sales), 0)
           return total
      },
        CREDIT(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.credit_sales), 0)
           return total
      },
      SC_CASH(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.service_charge), 0)
           return total
      },
    SC_CREDIT(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.service_charge_credit), 0)
           return total
      },
    GROSS(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.gross_sales), 0)
           return total
    },
      NET(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.net_sales), 0)
           return total
      },
      TOTAL(){
          return this.TICKET + this.PARKING + this.LABOR + this.COMMISSION
      }
  },
  methods: {
      emitToParent (action) {
      this.$emit('ReportEvent',action)
    },
       getTCL: function() {
         this.summaries = []
            this.$http.post("summary/query", JSON.stringify({for_date: this.selected_date})).then(response => {
                  response.data.data != null?this.summaries = response.data.data:this.summaries=[]
          }).catch(e => {
           console.log(e.data)
         })
      },
  }
}
</script>
